import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

type TInviteTeamTableHeader = {
  onClick: () => void
  isOnboarding?: boolean
};

const InviteTeamTableHeader: FC<TInviteTeamTableHeader> = ({ onClick, isOnboarding = true }) => {
  const { t } = useTranslation('team');

  return (
    <Box px={1} py={2} display="flex" justifyContent="flex-end">
      {isOnboarding && (
      <Button id="add-member" onClick={onClick}>
        {`+ ${t('addMember')}`}
      </Button>
      )}
    </Box>
  );
};

export {
  InviteTeamTableHeader,
};
